<div *ngIf="loading" class="loading">
  <circular-indicator style="align-self: center;" [percentage]="0" [size]="100">
  </circular-indicator>
</div>
<div class="container" [ngClass]="
  {
    'shell': origin === 'shell',
    '--maps-view': !showForm,
    'visible': !loading,
    'hidden': loading
  }" id="updateDeliveryPageTop">
  <!-- title -->
  <div class="container__content-text schedule" *ngIf="origin === 'schedule' || (origin === 'shell' && !showForm)">
    <h3 class="container__content-text__title" [class.label-error]="isValidFields && origin === 'shell'">
      {{ (origin !== 'schedule' ? "update-delivery-address.update-address" : "pickup-and-delivery.your-address") |
      translate }}
    </h3>
    <h5 class="container__content-text__sub-title">
      {{ (showForm ? "update-delivery-address.enter-the-data" : "update-delivery-address.select-position-map") |
      translate }}
    </h5>
  </div>

  <!-- form -->
  <button class="overlay" *ngIf="showFinder && enableAddressForm" (click)="blurAddressInput()"></button>
  <div class="container__content-form">
    <ng-container *ngIf="showForm">
      <form [formGroup]="updateAddress">
        <div class="autosuggest">
          <div [ngClass]="{'container__content-form__input-text-error': isValidAndTouched('control')}"
            class="container__content-form__input-text">
            <label for="control" [class.label-error]="!isValidFields && !containInputValue('control') && origin === 'shell'">
              {{ "update-delivery-address.form.address-label" | translate }}
              @if (!isValidFields && !containInputValue('control') && origin === 'shell') {
                <span class="required-field">({{ "my-account.my-data.mandatory" | translate }})</span>
              }              
            </label>
            <div class="search-wrapper" [ngClass]="{'active': enableAddressForm}">
              <img *ngIf="showIconsForm" src="./assets/images/icons/Icon_Search2.svg" alt="Search Icon"
                class="icon-search">
              <input
                id="searchAddress"
                type="text"
                [ngClass]="{'search-on': showIconsForm, 'error-input': isValidFields}"
                formControlName="control"
                placeholder="{{ (noStreetNumber ? 'update-delivery-address.form.address-without-number' : 'update-delivery-address.form.address') | translate }}">
              <img *ngIf="showIconsForm" src="./assets/images/icons/Icon_Close2.svg" alt="Clear Icon"
                (click)="clearSearch()" class="icon-clear">
            </div>
            @if (isValidFields) {
              <span class="required-field">{{ 'update-delivery-address.form.mandatory-message' | translate }}</span>
            }
          </div>
          <div *ngIf="enableSearch" class="autosuggest__list-suggestions"
            [ngClass]="{'active': showFinder && enableAddressForm}">
            <button *ngFor="let suggest of (suggestObservable$ | async)?.suggestions" (click)="getSuggest(suggest.placePrediction)">{{suggest.placePrediction.text.text }}</button>
          </div>
        </div>

        <div class="no-street-number-checkbox" *ngIf="(showIconsForm || noStreetNumber) && enableAddressForm">
          <label class="no-street-number-label">
            <input type="checkbox" id="noStreetNumber" [checked]="noStreetNumber" (change)="toggleNoStreetNumber($event)">
            {{ 'update-delivery-address.form.no-street-number' | translate }}
          </label>
        </div>

        <button class="target-on-map" *ngIf="enableAddressForm" (click)="handleShowForm(false)">{{
          'update-delivery-address.target-on-map' | translate }}</button>
        <!-- complement -->
        <ng-container>
          <div class="container__content-form__input-text">
            <label for="address3">
              {{ "update-delivery-address.form.complement" | translate }}
              <img class="checkmark" src="./assets/images/icons/Icon_Checkmark.svg"
                *ngIf="containInputValue('address3')" alt="checkmark for address3 input">
            </label>
            <input type="text" formControlName="address3" id="address3"
              placeholder="{{ 'update-delivery-address.form.complement' | translate }}" (input)="setComplement()"
              maxlength="200">
          </div>
        </ng-container>
      </form>
    </ng-container>
    @if (!showForm) {
    <button class="back-form" (click)="handleShowForm()">
      <span *ngIf="origin === 'schedule'">{{ 'schedule.back' | translate }}</span>
      <span *ngIf="origin === 'shell'">{{ 'commom.back' | translate }}</span>
    </button>
    }

    @if (showForm) {
      <lib-google-dynamic-map
        [icon]="'assets/images/icons/Icon_PIN.svg'"
        [isStatic]="showForm"
        [markers]="[{
          position: latLngLiteral!,
          title: '',
        }]"
      />
    } @else {
      <lib-google-dynamic-map
        [icon]="'assets/images/icons/Icon_PIN.svg'"
        [isStatic]="false"
        [markers]="[{
          position: latLngLiteral!,
          title: '',
        }]"
        (addressFound)="onSelectedAddressMap($event)"
      />
    }

  </div>
</div>

<div class="footer" [ngClass]="{'footer__shell': origin === 'shell'}"
  *ngIf="origin === 'schedule' || (origin === 'shell' && !showForm)">
  <div class="footer__inner">
    <button id="btn-back-advisor" *ngIf="origin !== 'shell'" (click)="backToRemoteExperience()"
      class="fmc-text-button custom-fmc-text-button" [disabled]="loading">
      {{'update-delivery-address.btn.cancel' | translate}}
    </button>
    <button id="btn-back-advisor" *ngIf="origin === 'shell'" (click)="handleShowForm()"
      class="fmc-text-button custom-fmc-text-button" [disabled]="loading">
      {{'update-delivery-address.btn.cancel' | translate}}
    </button>

    <lib-button *ngIf="showForm" type="primary" [rightIcon]="true" [disabled]="enableUpdateUserButton || loading" (clickButton)="onSubmit()">
      {{'update-delivery-address.btn.confirm' | translate}}
    </lib-button>

    <lib-button *ngIf="!showForm" type="primary" [rightIcon]="true" [disabled]="enableUpdateUserButton || loading" (clickButton)="handleShowForm()">
      {{'update-delivery-address.btn.confirm' | translate}}
    </lib-button>
  </div>
</div>
